<template>
  <div>
    <b-row class="row-fix">
      <b-col sm="8" class="column">
        <Introduction />
      </b-col>
      <b-col sm="4" class="column">
        <Calendar />
      </b-col>
    </b-row>
    <hr />
    <Maps />
  </div>
</template>

<script>
import Introduction from '@/components/home/Introduction'
import Calendar from '@/components/home/Calendar'
import Maps from '@/components/home/Maps'
export default {
  name: 'Homepage',
  components: {
    Introduction,
    Calendar,
    Maps,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.column{
  padding:0;
}

.row-fix{
  margin:0;
}

</style>
